module.exports = __webpack_public_path__ + "img/design.c9994c2.jpg";